import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { DataGridPremium, DataGridPremiumProps } from '@mui/x-data-grid-premium';

import whiteHeaderTheme from '../../theme/mui-data-grid-white-header-theme';

export const WhiteHeaderMUIDataGrid = (props: DataGridPremiumProps) => (
  <ThemeProvider theme={whiteHeaderTheme}>
    <DataGridPremium {...props} />
  </ThemeProvider>
);
